export const cancelParcelValues = {
  no: 'no',
  cancelOrder: 'cancel_order',
  resetFulfillment: 'reset_fulfillment',
}
